export default {
    tagsView: {
        refresh: '刷新',
        closeOthers: '关闭其他',
        closeAll: '关闭所有',
        close: '关闭',
        allTags: '所有标签页'
    },
    route: {
        index: '首页',
        IdentityInquire: '标识查询',
        identificationPrint: '标识生成与打印',
        IdentityInquireDetail: '标识详情',
        analysisReport: '标签使用分析报表',
        corporateIdentify: '企业标识对比分析报表',
        IdentifyRanking: '标识使用排行报表',
        abnormalLog: '异常日志',
        enterLog: '登入日志',
        permissionMaintain: '权限维护日志',
        productMaintenance: '产品维护日志',
        IdentityRegistrationLog: '标识注册日志',
        IdentityResolutionLog: '标识解析日志',
        operationLog: '操作日志',
        apiLog: '接口日志',
        processSearch: '条码全流程跟踪',
        filesSearch: '条码档案查询',
        scanBarCodeCenter: '条码中间表查询',
        processSearchOverseas: '条码全流程跟踪(海外)',
        scanCodeControll: '所有扫码率监控',
        codeAnalysis: '批量条码信息解析',
        domain: '领域表',
        scene: '场景表',
        node: '节点表',
        step: '步骤表',
        es: 'ES集群配置',
        oss: 'OSS配置',
        quota: '限额配置',
        tenant: '租户配置',
        product: '产品模板',
        publicproperty: '模板新增/修改',
        productcontrol: '产品管理',
        productProcess: '产品全流程',
        producttype: '产品新增/修改',
        productProcessNew: '产品全流程',
        barcodeMerge: '散件四码合一',
        barcodeArchive: '条码档案查询',
        homePage: '主页',
        companyPrefix: '企业前缀',
        recentNews: '最新动态',
        changeNews: '最新动态新增/修改',
        newPrefix: '企业前缀新增',
        changeNotice: '公告新增/修改',
        notice: '公告/问题',
        detailsNotice: '公告详情',
        dataDictionary: '数据字典',
        tenantRelations: '租户表关系配置'
    },
    home: {

    },
    developer: {
        message: '你好，开发者页面！'
    }
};
